// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-9d17baec] .icon-mr-0 {\r\n  margin-right: 0 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
